import { EPSProducts, HealthProducts } from "src/constants/product-codes";
import { AttentionType } from "src/domains/medicine-delivery/presentation/pages/basic-data/types";
import { Log } from "src/libs/log";
import { Clinic } from "src/shared/models/clinic.model";

type ClinicJson = Omit<InstanceType<typeof Clinic>, "toJson" | "fromJson">;

async function getClinicsFallback(
    productCode: string,
    attentionType: AttentionType
): Promise<ClinicJson[]> {
    Log.info("Getting clinics by:", { productCode, attentionType });
    let clinicsImport: Promise<{ default: ClinicJson[] }>;
    if (attentionType === "Ambulatoria") {
        switch (productCode) {
            case HealthProducts.VIDA_INTERNACIONAL: {
                clinicsImport = import(
                    "../presentation/assets/data/clinicas-mint.json"
                );
                break;
            }
            case HealthProducts.VIDA_NACIONAL:
            case HealthProducts.MEVI: {
                clinicsImport = import(
                    "../presentation/assets/data/clinicas-mnac.json"
                );
                break;
            }
            case HealthProducts.MLTS:
            case HealthProducts.MULTISALUD: {
                clinicsImport = import(
                    "../presentation/assets/data/clinicas-msld.json"
                );
                break;
            }
            case HealthProducts.SALUD_PREFERENTE: {
                clinicsImport = import(
                    "../presentation/assets/data/clinicas-am05.json"
                );
                break;
            }
            case EPSProducts.EPS_REGULAR:
            case EPSProducts.EPS_INDIVIDUAL:
            case "R":
            case "I": {
                clinicsImport = import(
                    "../presentation/assets/data/clinicas-eps.json"
                );
                break;
            }
            default: {
                clinicsImport = import(
                    "../presentation/assets/data/clinicas-eps.json"
                );
            }
        }
    } else {
        clinicsImport = import(
            "../presentation/assets/data/clinicas-oftalmologia.json"
        );
    }

    try {
        const { default: clinicsJson } = await clinicsImport;
        return clinicsJson;
    } catch (err) {
        Log.warn("Ocurrió un error al leer las clínicas:", err);
        return [];
    }
}

export { getClinicsFallback };
